/*/
 * Swiper v8
/*/
	import Swiper, { Navigation } from 'swiper';

	const siteSwiperCategories = new Swiper('[site-categories]', {
		loop: false,
		slidesPerView: 'auto',
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		on: {
			init() {
				const wrapperSize = this.size
				const slidesSize = this.slidesSizesGrid.reduce((prev, current) => prev + current, 0)

				if (slidesSize > wrapperSize) {
					this.$wrapperEl[0].classList.add('justify-content-start')
				} else {
					this.$wrapperEl[0].classList.remove('justify-content-start')
				}
			},
			resize() {
				const wrapperSize = this.size
				const slidesSize = this.slidesSizesGrid.reduce((prev, current) => prev + current, 0)

				if (slidesSize > wrapperSize) {
					this.$wrapperEl[0].classList.add('justify-content-start')
				} else {
					this.$wrapperEl[0].classList.remove('justify-content-start')
				}
			}
		}
	})

	const siteSwiperGallery = new Swiper('[site-swiper-gallery]', {
		modules: [Navigation],
		loop: false,
		slidesPerView: 1,
		spaceBetween: 16,
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		navigation: {
			prevEl: '.swiper-gallery-prev',
			nextEl: '.swiper-gallery-next',
		},
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			}
		}
	})

	const siteSwiperRelated = new Swiper('[site-swiper-related]', {
		modules: [Navigation],
		loop: false,
		slidesPerView: 1,
		spaceBetween: 16,
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		navigation: {
			prevEl: '.swiper-related-prev',
			nextEl: '.swiper-related-next',
		},
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			}
		}
	})
